import * as Sentry from '@sentry/vue';
const logger = {
	environment: 'testing',
	console_log: [],
	disabled: false,
	prevent_logs_from_going_to_devtools: false,
	debug_mode: false,
	performance_mode: false,

	initSentry() {
		Sentry.init({
			dsn: import.meta.env.VITE_DEFAULT_SENTRY_DSN,
			environment: this.environment,
		});

		Sentry.configureScope(function (scope) {
			scope.setLevel('error');
		});
	},

	parseURLParams() {
		const url_params = new URLSearchParams(window.location.search);
		this.environment = url_params.get('env') || this.environment; // Assuming 'env' is used for environment
		this.debug_mode = url_params.get('debug') == 'true';

		// Update logger properties based on parsed URL parameters
		if (this.debug_mode == 'true') {
			this.prevent_logs_from_going_to_devtools = true;
		}
		if (url_params.get('perf') == 'true') {
			this.performance_mode = true;
		}
		if (url_params.get('logger') == 'true') {
			this.disabled = false;
		}
		if (url_params.get('logger') == 'false') {
			this.disabled = true;
		}
		if (window.location.hostname == 'localhost') {
			this.disabled = true;
		}
	},

	getCircularReplacer() {
		const seen = new WeakSet();
		return (key, value) => {
			if (typeof value === 'object' && value !== null) {
				if (seen.has(value)) {
					return '[Circular]';
				}
				seen.add(value);
			}
			return value;
		};
	},

	generateConsoleLogJSONBlob: function () {
		const log_data = JSON.stringify(this.console_log, this.getCircularReplacer(), 2);
		const blob = new Blob([log_data], { type: 'application/json' });
		return blob;
	},

	downloadConsoleLog() {
		const blob = this.generateConsoleLogJSONBlob();
		const url = URL.createObjectURL(blob);
		const a = document.createElement('a');
		a.href = url;
		a.download = `Elevate_Console_Log_${Date.now()}.json`;
		document.body.appendChild(a);
		a.click();
		document.body.removeChild(a);
		URL.revokeObjectURL(url);
	},

	interceptConsoleMethods() {
		if (this.disabled == true) {
			return;
		}

		const original_log = console.log;
		const original_warn = console.warn;
		const original_error = console.error;

		console.log = (...args) => {
			if (this.disabled === false || (this.performance_mode === true && args[0] !== 'error')) {
				const event_log = this.getLogEvent('log', args);
				this.console_log.push(event_log);
			}

			if (this.prevent_logs_from_going_to_devtools != true) {
				original_log.apply(console, args);
			}
		};

		console.warn = (...args) => {
			if (this.disabled === false || (this.performance_mode === true && args[0] !== 'error')) {
				const event_log = this.getLogEvent('warn', args);

				this.console_log.push(event_log);
			}
			if (this.prevent_logs_from_going_to_devtools != true) {
				original_warn.apply(console, args);
			}
		};

		console.error = (...args) => {
			if (this.disabled === false) {
				const event_log = this.getLogEvent('error', args);

				this.console_log.push(event_log);
			}

			if (this.prevent_logs_from_going_to_devtools != true) {
				original_error.apply(console, args);
			}
		};
	},

	getLogEvent(type, args) {
		const stack_trace = new Error().stack || '';
		const stack_lines = stack_trace.split('\n');
		const filtered_stack_lines = stack_lines.filter((line) => !line.includes('node_modules') && !line.includes('loggerService.js'));
		const location_stack = filtered_stack_lines.length >= 1 ? filtered_stack_lines[1] : '';

		const match_result = /at\s+(?:Object\.)?(.+)\s+\((.*):(\d+):(\d+)\)/.exec(location_stack);
		const line_number = match_result ? match_result[3] || '' : '';
		const column_number = match_result ? match_result[4] || '' : '';

		let original_file_name = '';
		let original_url = '';

		if (match_result) {
			// eslint-disable-next-line no-useless-escape
			const source_match = /((http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*)?)/.exec(match_result[2]);
			original_url = source_match ? source_match[1] || '' : '';
			original_file_name = match_result[2].split('/').pop() || '';
		}

		return {
			date: new Date().toISOString(),
			arguments: args,
			log_type: type,
			location: `${original_file_name}:${line_number}:${column_number}`,
			location_components: {
				url: original_url,
				line_number,
				column_number,
			},
			stack: stack_trace,
		};
	},
};

export default logger;
